import Breadcrumbs from "components/Common/Breadcrumb"
import React, { useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import { Button, Card, CardBody, Col, Row } from "reactstrap"
import ReactQuill from "react-quill"
import "react-quill/dist/quill.snow.css"
import DataExportDropdown from "components/Shared/DataExportDropdown"
import {
  getPageContentByType,
  updatePageContentByType,
} from "store/actions/faqAction"
import { showAlert } from "store/reducers/alertReducer"
import Spinners from "components/Shared/Spinners"
import { useNavigate } from "react-router-dom"
import isPermissionEnabled from "common/isPermissionEnabled"
import { editorFormats, editorModules } from "components/Common/constants"

const PrivacyPolicy = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation()

  document.title = t("Privacy Policy | Sign Burger")

  const navigate = useNavigate()
  const dispatch = useDispatch()
  const quillRefAr = useRef(null)

  const { loading, isLoading, pageContent } = useSelector(state => state.Faqs)

  const { userRole, accountType } = useSelector(state => state.Login)

  const [usersPermissions, setUsersPermissions] = useState({
    list: null,
    edit: null,
  })

  // FIRST CHECK PERMISSION, IF DOES'T HAVE THEN REDIRECT TO DASHBOARD
  useEffect(() => {
    const isPermissionList = isPermissionEnabled(
      userRole,
      34,
      "privacy_policy_1",
      accountType
    )

    const isPermissionEdit = isPermissionEnabled(
      userRole,
      34,
      "privacy_policy_3",
      accountType
    )

    if (!isPermissionList) {
      navigate("/dashboard")
    } else {
      fetchContent()
    }
    setUsersPermissions({
      list: isPermissionList,
      edit: isPermissionEdit,
    })
  }, [userRole])

  const [description, setDescription] = useState("")
  const [descriptionAr, setDescriptionAr] = useState("")

  const fetchContent = () => {
    const payload = {
      type: "PrivacyPolicy",
    }
    dispatch(getPageContentByType(payload))
  }

  useEffect(() => {
    const editor = quillRefAr?.current?.getEditor()
    if (editor) {
      const root = editor.root
      root.setAttribute("dir", "rtl")
      root.style.textAlign = "right"
    }
  }, [pageContent])

  useEffect(() => {
    if (pageContent) {
      const { description, descriptionAr } = pageContent
      setDescription(description)
      setDescriptionAr(descriptionAr)
    }
  }, [pageContent])

  const handleSubmit = () => {
    const payload = {
      type: "PrivacyPolicy", // TermsAndConditions , PrivacyPolicy
      title: "Privacy Policy", // STATIC
      titleAr: "سياسة الخصوصية", // STATIC
      description,
      descriptionAr,
    }

    dispatch(updatePageContentByType(payload))
      .then(action => {
        const { statusCode, status, msg } = action?.payload
        if (statusCode === 200 && status) {
          dispatch(showAlert({ text: msg, type: "success" }))
        } else {
          dispatch(showAlert({ text: msg, type: "error" }))
        }
      })
      .catch(error => {})
  }

  if (loading) return <Spinners />

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs />
        <Card>
          <CardBody className="border-bottom">
            <Row>
              <Col xl={12}>
                <div className="d-flex align-items-center">
                  <h5 className="mb-0 card-title flex-grow-1">
                    {t("Privacy Policy")}
                  </h5>
                </div>
              </Col>
              <div className="mt-4"></div>
              <Col lg={6}>
                <h6 className="fw-bold">{t("English")}</h6>
              </Col>
              <Col lg={6}>
                <h6 className="fw-bold">{t("Arabic")}</h6>
              </Col>
              <Col lg={6}>
                <ReactQuill
                  value={description}
                  onChange={setDescription}
                  placeholder={t("Write your privacy policy here...")}
                  readOnly={usersPermissions?.edit ? false : true}
                  modules={editorModules}
                  formats={editorFormats}
                />
              </Col>
              <Col lg={6}>
                <div style={{ direction: "rtl" }}>
                  <ReactQuill
                    ref={quillRefAr}
                    value={descriptionAr}
                    onChange={setDescriptionAr}
                    placeholder={t("اكتب شروطك وأحكامك هنا...")}
                    readOnly={usersPermissions?.edit ? false : true}
                    modules={editorModules}
                    formats={editorFormats}
                  />
                </div>
              </Col>
              <div className="d-flex justify-content-end mt-3">
                {usersPermissions?.edit && (
                  <Button
                    type="submit"
                    color="success"
                    disabled={isLoading}
                    onClick={handleSubmit}
                  >
                    {t("Update")}
                  </Button>
                )}
              </div>
            </Row>
          </CardBody>
        </Card>
      </div>
    </div>
  )
}

export default PrivacyPolicy
